import React from "react"

import { GridLines, Logo } from "@shared"
import { css } from "@jsUtils"

// import { PageSection } from "../PageSection"
import { Nav } from "../Nav"

import Styles from "./header.module.scss"

/**
 * Header wrapper for the site
 * @param {object} props - react props
 * @param {string} props.theme - which theme to carry down from page
 *  (this has been changed to not drive the open nav color, which is always white)
 * @param {string} props.pageColor - what forground color FOR the page
 */
const Header = ({ theme, pageColor, showNavlinks = true, showGridLines = true }) => {
  return (
    <header className={css(Styles.header, Styles[`theme__${theme}`])}>
      {showGridLines && <GridLines theme={theme} />}
      <Logo theme={theme} overrideClass="headerLogoIEOverride" />
      {showNavlinks && <Nav theme={theme} pageColor={pageColor} />}
    </header>
  )
}

export default Header
